import "core-js/modules/web.dom-collections.iterator.js";
import React, { useState } from 'react';
import { Icon, IconTypes } from '@eika/icon';
import { Link } from '@eika/link';
import UforekalkulatorCalculations from './UforekalkulatorCalculations';
import UforekalkulatorInputField from './UforekalkulatorInputField';
import { defaultYearlyIncome, grunnbelop } from './constants';
import './style.scss';
const Uforekalkulator = _ref => {
  let {
    navUforeLink,
    children
  } = _ref;
  const [yearlyIncome, setYearlyIncome] = useState(defaultYearlyIncome);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "uforekalkulator"
  }, /*#__PURE__*/React.createElement("div", {
    className: "top-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header"
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "icon--36",
    type: IconTypes.KALKULATOR_36
  }), /*#__PURE__*/React.createElement("h3", null, "Uf\xF8rekalkulator")), /*#__PURE__*/React.createElement("p", null, "Sjekk hvor mye du f\xE5r i inntektstap hvis du blir 100% uf\xF8r"), /*#__PURE__*/React.createElement("p", {
    className: "yearly-income"
  }, "Din \xE5rsinntekt f\xF8r skatt"), /*#__PURE__*/React.createElement(UforekalkulatorInputField, {
    value: yearlyIncome,
    setValue: setYearlyIncome
  })), /*#__PURE__*/React.createElement(UforekalkulatorCalculations, {
    yearlyIncome: yearlyIncome,
    grunnbelop: grunnbelop
  }), /*#__PURE__*/React.createElement("div", {
    className: "button-content"
  }, /*#__PURE__*/React.createElement(Link, {
    className: "link-nav",
    href: navUforeLink,
    target: "_blank",
    iconOnRightSide: true,
    icon: IconTypes.ExternalLink,
    size: "large"
  }, "Les mer p\xE5 NAV sine sider")), children));
};
export default Uforekalkulator;